import React, { useState } from "react";
import TestResult from "../components/Test/TestResult";
import Aside from "../modules/SideNav/Aside";

function TestResultLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <TestResult />
      {/* Liju */}
    </div>
  );
}

export default TestResultLayout;
